import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {BluetoothSerial} from "@ionic-native/bluetooth-serial";
import {ToastProvider} from "../toast/toast";
import {Events} from "ionic-angular";

/*
  Generated class for the BluetoothProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BluetoothProvider {

  constructor(public http: HttpClient, private bluetooth: BluetoothSerial, private toast: ToastProvider, public events: Events) {

  }

  search() {
    return this.bluetooth.list();
  }

  connect(address) {
    return new Promise((resolve, reject) => {
      this.bluetooth.connect(address).subscribe(
        success => {
            //set the default times a printer will print.
            const printCount = localStorage.getItem('print_count');
            if(!printCount) {
              localStorage.setItem('print_count', "2");
            }
            resolve(true);
          // this.toast.presentToast('Printer Connected Successfully')
        },
        error => {
          this.toast.presentToast('Connected Failed');
          reject(false);
        }
      )
    })

  }

  print(message) {
    this.bluetooth.write(message).then( success => {
      this.toast.presentToast('Print Successfully',1000)
    }, error => {
      this.toast.presentToast(`Print Failed, ${error}`,1000)
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/providers/bluetooth/bluetooth.ts